// extracted by mini-css-extract-plugin
module.exports = {"container":"LayoutPage_container__DHVlv","lds-ripple":"LayoutPage_lds-ripple__7Qamr"};